import React from 'react'
import styled from 'styled-components'

function ProgressBar({title, width, text}) {
    return (
        <ProgressBarStyled>
            <h6>{title}</h6>
            <div className="progress-barr">
                <p>{text}</p>
                <div className="progresss">
                    <span style={{ width: width }}></span>
                </div>
            </div>
        </ProgressBarStyled>
    )
}

const ProgressBarStyled = styled.div`
    .progress-barr {
        display: flex;
        /* flex-direction: row; */
        align-items: center;
        /* justify-content: center; */
        background-color: var(--background-dark-color);
        p{
            padding-right: 1.2rem;
        }
        .progresss {
            position: relative;
            width: 100%;
            height: .4rem;
            background-color: var(--border-color);
            top: -10px;
            span {
                position: absolute;
                left: 0;
                bottom: 0;
                height: 100%;
                background-color: var(--primary-color);
            }
        }
    }
`;

export default ProgressBar;
